var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.letters),function(letter,index){return _c('div',{key:index,class:_vm.guess.Ratings[index]},[_vm._v(" "+_vm._s(letter)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }